var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.85352 4.51982L5.10352 6.26982M10.5215 0.454572C10.5769 0.43547 10.6365 0.432327 10.6935 0.445501C10.7506 0.458674 10.8028 0.487634 10.8442 0.529069C10.8855 0.570505 10.9144 0.622745 10.9275 0.679819C10.9406 0.736892 10.9374 0.796498 10.9182 0.851822L7.46252 10.7277C7.44184 10.7867 7.4039 10.8381 7.35361 10.8754C7.30333 10.9126 7.24303 10.9338 7.18053 10.9363C7.11803 10.9388 7.05621 10.9225 7.0031 10.8895C6.94999 10.8564 6.90804 10.8082 6.88268 10.751L5.00493 6.52649C4.97334 6.45624 4.9171 6.4 4.84685 6.3684L0.62235 4.49007C0.565356 4.46463 0.517301 4.42267 0.484394 4.36963C0.451487 4.3166 0.435241 4.25491 0.437753 4.19254C0.440265 4.13017 0.461421 4.06999 0.498487 4.01977C0.535553 3.96955 0.586827 3.9316 0.645684 3.91082L10.5215 0.454572Z",
    stroke: "#262F5F",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.a04fdf3ba40be8a7b20f1cfb7a29905c.svg";
export { ForwardRef as ReactComponent };